import { createFileRoute, Outlet } from '@tanstack/react-router';
import { DashboardAuthRequired } from '../auth/dashboard-auth-wrapper';
import { DashboardTopNavigation } from '../common/navigation/dashboard-navigation';

export const Route = createFileRoute('/dashboard')({
  component: DashboardLayout,
});

function DashboardLayout() {
  return (
    <DashboardAuthRequired>
      <DashboardTopNavigation />
      <Outlet />
    </DashboardAuthRequired>
  );
}
